import {DateTime} from 'luxon';

const IGNORE_WORDS = [
    'timezone',
    'timestostayotr',
    'timeframe',
    'ctltimes',
    'samsmaxtimestoincrease',
    'otrtimestostayotr',
    'otrmaxtimesdoubleotrbetonloss',
    'alterotrtimestostayotr',
    'charttimeframe',
    'timestampszone',
    'exchangetimezoneid',
    'timeofday',
    'optionexpirationdate',
    'optionexpirationdisplaydate',
    'timezoneid',
    'converttomarkettime',
    'ctmtimezone',
    'ctmtimestoreplace',
    'ctmactiontime',
    'ctmactiontimemode',
    'sellactiontimemode',
    'sellactiontime',
    'sellactiontimezone',
    'rolltimezone',
    'rolltimemode',
    'rolltime',
    'expirationDate',
    'expirationdate',
    'adjustmenttime',
    'adjustmenttimeMode',
    'adjustmenttimemode',
    'adjustmenttimezone',
    'converttime',
    'converttimezone',
    'reversetimedirection',
    'timestoreplace',
    'chargetime',
    'chargetimeofday',   // Collars interest "HH:mm" wall-clock — "time"+"date" trips the heuristic, but
                         // it is NOT a date; without this the reviver turns it into a JS Date that
                         // re-serializes as a full ISO string the backend's HH:mm parser rejects, so a
                         // re-save of unchanged interest settings fails unless the time is re-picked.
    'chargetimezone',
    'actiontime',
    'actiontimemode',
    'starttime',
    'endtime',
    'timestamp',
    'bartime',
    'isotimestamp',
    // Collars retro-fill preview P&L numbers — "lifeTIME" trips the 'time' heuristic, but these are
    // money amounts, not dates. Without these the DecimalPipe receives a (bogus) Date and the preview
    // panel renders empty (CR-20260610-001).
    'lifetimebefore',
    'lifetimeafter',
];

export function customJsonParser(key: string, value: any) {
    if (!value) {
        return value;
    }

    let parsed: any;
    const lowerCaseKey = key.toLowerCase();
    const hastriggerWords = lowerCaseKey.includes('time') || lowerCaseKey.includes('date');
    const shouldIgnore = IGNORE_WORDS.includes(lowerCaseKey);
    if (hastriggerWords && !shouldIgnore) {
        parsed = DateTime.fromISO(value, {zone: 'UTC'}).toJSDate();
        if (Object.prototype.toString.call(parsed) === '[object Date]') {
            if (isNaN(parsed)) { // d.getTime() or d.valueOf() will also work
                parsed = value;
            }
        } else {
            parsed = value;
        }
    } else {
        parsed = value;
    }
    return parsed;
}
